import "./styles.css";
import { bootApp } from "./ui/app";

const root = document.querySelector<HTMLElement>("#app");

if (!root) {
  throw new Error("Missing #app root.");
}

void bootApp(root).catch((error: unknown) => {
  const message = error instanceof Error ? error.message : String(error);
  root.innerHTML = `
    <main class="boot-error">
      <h1>SkyView Web could not start</h1>
      <p>${message}</p>
    </main>
  `;
});

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/service-worker.js");
  });
}
